/** Helpers de formatage uniformes (montants, dates, badges). */

export function formatAmount(minor: number, currency: string): string {
  if (currency === "USD" || currency === "EUR") {
    return `${(minor / 100).toFixed(2)} ${currency}`;
  }
  return `${minor.toLocaleString("fr-FR")} ${currency}`;
}

/** Formate un tableau de volumes multi-devises pour affichage inline.
 * Ex: [{USD, 253689}, {CDF, 10000}] -> "2536.89 USD + 10 000 CDF"
 * Vide -> "0"
 */
export function formatVolumes(
  volumes: Array<{ currency: string; amount_minor: number }> | undefined | null,
): string {
  if (!volumes || volumes.length === 0) return "0";
  return volumes.map((v) => formatAmount(v.amount_minor, v.currency)).join(" + ");
}

export function formatBps(bps: number): string {
  return `${(bps / 100).toFixed(2)}%`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return `il y a ${sec}s`;
  if (sec < 3600) return `il y a ${Math.floor(sec / 60)}min`;
  if (sec < 86400) return `il y a ${Math.floor(sec / 3600)}h`;
  return `il y a ${Math.floor(sec / 86400)}j`;
}

export const STATUS_COLORS: Record<string, string> = {
  succeeded: "bg-emerald-100 text-emerald-800",
  active: "bg-emerald-100 text-emerald-800",
  failed: "bg-red-100 text-red-800",
  suspended: "bg-red-100 text-red-800",
  abandoned: "bg-red-100 text-red-800",
  pending: "bg-amber-100 text-amber-800",
  processing: "bg-blue-100 text-blue-800",
  retrying: "bg-amber-100 text-amber-800",
  cancelled: "bg-slate-100 text-slate-700",
  expired: "bg-slate-100 text-slate-700",
  complete: "bg-emerald-100 text-emerald-800",
  open: "bg-blue-100 text-blue-800",
};

export function statusBadge(status: string): string {
  return STATUS_COLORS[status] ?? "bg-slate-100 text-slate-700";
}
